export function isExternalPLALander({
  params,
  referer,
}: {
  params?: URLSearchParams;
  referer?: string | null;
}) {
  const isGoogleAdReferer =
    params?.has('gclid') ||
    (params?.has('~channel') &&
      params?.get('~channel')?.toLowerCase() === 'pla');
  const isExternalReferer = Boolean(referer && !referer.includes('depop.com'));

  return isGoogleAdReferer || isExternalReferer;
}
